import React from "react";
import { useNavigate } from "react-router-dom";
import { ImageOff } from "lucide-react";

const SearchProductCard = ({ image, name, price, slug, onClose, currency }) => {
  const navigate = useNavigate();

  const handleProductClick = () => {
    onClose();
    navigate(`/product/${slug}`);
  };

  return (
    <div className="flex items-center p-4 ">
      {/* Left Image */}
      <div className="relative w-20 h-20 overflow-hidden rounded mr-4 flex-shrink-0">
        {image ? (
          <img
            src={image}
            alt={name}
            onClick={handleProductClick}
            className="w-full h-full object-cover hover:cursor-pointer hover:opacity-80 transition-opacity"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        
        {/* Fallback placeholder */}
        <div 
          className={`${image ? 'hidden' : 'flex'} w-full h-full bg-gray-200 rounded cursor-pointer items-center justify-center flex-col text-gray-500 hover:opacity-80 transition-opacity`}
          style={{ display: image ? 'none' : 'flex' }}
          onClick={handleProductClick}
        >
          <ImageOff size={16} className="mb-1 opacity-50" />
          <span className="text-xs font-medium">No Image</span>
        </div>
      </div>

      {/* Right Content */}
      <div className="grid gap-1">
        <h3 
          onClick={handleProductClick} 
          className="text-lg font-medium text-gray-800 hover:cursor-pointer hover:text-gray-600 transition-colors"
        >
          {name}
        </h3>
        <p className="text-xl font-medium text-gray-800"> {`${currency} ${price}`}</p>
      </div>
    </div>
  );
};

export default SearchProductCard;